module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step2_Image9.81f76a53.jpg";